import React from "react";
import FormFields from "./FormFields";

const FormFieldsWrapper = (props) => {
  return (
<>   
    <FormFields
      {...props}
      {...(props.checkType
        ? props.checkType(props?.FormikForm?.values)
        : { type: props.type })}
    />
    {/* <Typography variant='body2' sx={{
          fontSize: "0.75rem",
          opacity: 0.7
        }}
      >
        {isImportant && `The ${title} field is a valuable addition`}
      </Typography> */}
      </> 
  );
};

export default React.memo(FormFieldsWrapper, (prevProps, nextProps) => {
  const name = prevProps.name;

  // Other country remaps this field to a text input named `state`.
  if (name === "stateProvinceId") return false;

  // 1. Compare basic props
  if (prevProps.name !== nextProps.name) return false;
  if (prevProps.type !== nextProps.type) return false;
  if (prevProps.title !== nextProps.title) return false;
  if (prevProps.disabled !== nextProps.disabled) return false;
  if (prevProps.readonly !== nextProps.readonly) return false;
  if (prevProps.disableFields !== nextProps.disableFields) return false;
  if (prevProps.required !== nextProps.required) return false;
  if (prevProps.maxLength !== nextProps.maxLength) return false;
  if (prevProps.className !== nextProps.className) return false;
  if (prevProps.placeholder !== nextProps.placeholder) return false;
  if (prevProps.options !== nextProps.options) return false;

  // 2. Compare Formik Values
  if (prevProps.FormikForm?.values?.[name] !== nextProps.FormikForm?.values?.[name]) return false;

  // Errors & Touched status
  if (prevProps.FormikForm?.errors?.[name] !== nextProps.FormikForm?.errors?.[name]) return false;
  if (prevProps.FormikForm?.touched?.[name] !== nextProps.FormikForm?.touched?.[name]) return false;

  // 3. Conditional / Field-Specific Values
  // Check country fields if phone/country-related:
  if (prevProps.type === "phone" || name === "phone" || name === "countryCode" || name === "countryISOCode") {
    if (prevProps.FormikForm?.values?.["countryISOCode"] !== nextProps.FormikForm?.values?.["countryISOCode"]) return false;
    if (prevProps.FormikForm?.values?.["countryCode"] !== nextProps.FormikForm?.values?.["countryCode"]) return false;
    if (prevProps.FormikForm?.values?.["phone"] !== nextProps.FormikForm?.values?.["phone"]) return false;
  }

  // Check select combo selectName
  if (prevProps.selectName) {
    const sName = prevProps.selectName;
    if (prevProps.FormikForm?.values?.[sName] !== nextProps.FormikForm?.values?.[sName]) return false;
  }

  // Check tagsInput values
  if (prevProps.type === "tagsInput") {
    if (prevProps.FormikForm?.values?.["tags"] !== nextProps.FormikForm?.values?.["tags"]) return false;
    if (prevProps.serverData?.leadTags !== nextProps.serverData?.leadTags) return false;
  }

  // Check source filtering dependencies (like stateProvinceId depends on countryId)
  if (prevProps.source?.filterKey) {
    const fKey = prevProps.source.filterKey;
    if (prevProps.FormikForm?.values?.[fKey] !== nextProps.FormikForm?.values?.[fKey]) return false;
  } else if (prevProps.source?.store === "states" || prevProps.source?.store === "statesProvinces") {
    // If it's a states dropdown, it filters by countryId by default:
    if (prevProps.FormikForm?.values?.["countryId"] !== nextProps.FormikForm?.values?.["countryId"]) return false;
  }

  // 4. Compare Server data
  if (prevProps.serverData?.[name] !== nextProps.serverData?.[name]) return false;
  if (prevProps.serverData?.[prevProps.selectName] !== nextProps.serverData?.[nextProps.selectName]) return false;

  // 5. Evaluate checkType change if present
  if (prevProps.checkType) {
    const prevChecked = prevProps.checkType(prevProps.FormikForm?.values);
    const nextChecked = nextProps.checkType(nextProps.FormikForm?.values);
    if (prevChecked?.type !== nextChecked?.type) return false;
    const resolvedName = nextChecked?.name || name;
    if (
      prevProps.FormikForm?.values?.[resolvedName] !==
      nextProps.FormikForm?.values?.[resolvedName]
    )
      return false;
  }

  return true;
});
